import { useMemo } from "react";
import { useLegalFlowNotificacionesRpc } from "@/hooks/useLegalFlowExpedientes";
import { componerNotificaciones, type NotificacionLegalFlow } from "@/lib/legal-flow/notificacionesLegalFlow";

export type {
  NivelNotificacionLegal,
  NotificacionLegalFlow,
  TipoNotificacionLegal,
} from "@/lib/legal-flow/notificacionesLegalFlow";

/**
 * Notificaciones reales de SOZU Legal Flow (campana del header y pantalla Notificaciones):
 *
 * 1. Expedientes que piden acción, con su etapa real: Solicitud recibida, En revisión legal y
 *    Firma titular (contrato firmado pendiente de validar).
 * 2. Bitácora reciente (14 días): rechazos y validaciones de documentos.
 *
 * Una sola llamada a `legal_flow_notificaciones`. Antes el layout montaba en TODAS las pantallas
 * los hooks de recibidas y firma titular (más de 60 peticiones) solo para el contador.
 */
export function useNotificacionesLegalFlow() {
  const query = useLegalFlowNotificacionesRpc();
  const data = useMemo<NotificacionLegalFlow[]>(
    () => (query.data ? componerNotificaciones(query.data) : []),
    [query.data],
  );
  return {
    data,
    isLoading: query.isLoading,
    error: query.error,
    // La pantalla ofrece "Reintentar" cuando falla la carga.
    refetch: query.refetch,
  };
}
